import { MessageCircle } from "lucide-react";
import { whatsappLink } from "@/config/site";
import { track } from "@/lib/analytics";

export const FloatingCTA = () => (
  <a
    href={whatsappLink()}
    onClick={() => track.whatsappClick("floating")}
    target="_blank"
    rel="noreferrer"
    data-testid="floating-whatsapp"
    aria-label="Chat on WhatsApp"
    className="fixed bottom-5 right-5 z-40 flex items-center gap-2 rounded-full bg-[#25D366] px-4 py-3.5 font-bold text-white shadow-xl shadow-black/20 transition-transform hover:scale-105"
  >
    <MessageCircle size={22} />
    <span className="hidden sm:inline">WhatsApp Us</span>
  </a>
);
